// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2FS0O","alert":"SettungsInbox_alert__3G0ac"};